import { gql } from "@apollo/client";

const GET_USER_GROUPS = gql`
  query userGroups(
    $searchTerm: String
    $sortDirection: SortDirection
    $skip: Int
    $take: Int
  ) {
    userGroups(
      searchTerm: $searchTerm
      sortDirection: $sortDirection
      skip: $skip
      take: $take
    ) {
      totalCount
      items {
        id
        description
        isSystemGroup
        memberCount
        members {
          id
          isGroupAdmin
          skynetUserId
          skynetUser {
            firstName
            lastName
            email
          }
        }
        name
        permissions {
          admin {
            defaultRead
            defaultWrite
            maxRead
            maxWrite
          }
          aml {
            defaultRead
            defaultWrite
            maxRead
            maxWrite
          }
          client {
            defaultRead
            defaultWrite
            maxRead
            maxWrite
          }
          file {
            defaultRead
            defaultWrite
            maxRead
            maxWrite
          }
          invoice {
            defaultRead
            defaultWrite
            maxRead
            maxWrite
          }
          onboarding {
            defaultRead
            defaultWrite
            maxRead
            maxWrite
          }
        }
      }
    }
  }
`;

export default GET_USER_GROUPS;
